import { mdiBriefcaseUpload } from "@mdi/js";
import { Icon } from "@mdi/react";
import { CloudUpload, Done } from "@mui/icons-material";
import { Chip, CircularProgress } from "@mui/material";
import { statusType } from "types";

const StatusChip = ({ status }: { status: string }) => {
  switch (status) {
    case statusType.Uploading:
      return <Chip color="primary" icon={<CloudUpload />} label={status} />;
    case statusType.Uploaded:
      return (
        <Chip
          sx={{ color: "grey.300", bgcolor: "#FAEBCD", pl: 1 }}
          icon={<Icon path={mdiBriefcaseUpload} size={0.75} />}
          label={status}
        />
      );
    case statusType.Translating:
      return (
        <Chip
          sx={{ bgcolor: "rgba(58, 84, 101, 1)", color: "white" }}
          icon={<CircularProgress size={12} sx={{ color: "white" }} />}
          label={"Translating"}
        />
      );
    case statusType.Translated:
      return (
        <Chip sx={{ bgcolor: "#94D097" }} icon={<Done />} label={status} />
      );
    case statusType.Scheduled:
      return <Chip sx={{ bgcolor: "#F7C873" }} label={status} />;
    case statusType.Posted:
      return <Chip sx={{ bgcolor: "#94D097" }} label={status} />;
    case statusType.Failed:
      return <Chip color={"error"} label={status} />;
    default:
      return (
        <Chip
          sx={{ bgcolor: "#3A5465", color: "white" }}
          icon={<CircularProgress size={12} sx={{ color: 'white' }}/>}
          label={"Processing"}
        />
      );
  }
};

export default StatusChip;
